import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Box, Flex, Text } from 'core/ui/atoms';
import { ReactComponent as EditLine } from 'core/assets/images/V2/icons/EditLine.svg';
import useUser from 'core/hooks/useUser';

const DeliveryAddress = ({ type = 'large', title = 'This Week Delivery Address' }) => {
  const { currentUser } = useUser();
  const { primaryAddress = {}, firstName = '', lastName = '' } = currentUser || {};

  if (type === 'large') {
    return (
      <CustomBox>
        <HeaderText>{title}</HeaderText>
        <Flex justifyContent='space-around'>
          <AddressContainer>
            <AddressText>{`${firstName} ${lastName}`}</AddressText>
            <AddressText>{`${primaryAddress?.street1} ${primaryAddress?.street2}`}</AddressText>
            <AddressText>{`${primaryAddress?.city}, ${primaryAddress?.state}, ${primaryAddress?.zipCode} US`}</AddressText>
          </AddressContainer>
          <EditLine />
        </Flex>
      </CustomBox>
    );
  } else if (type === 'small') {
    return (
      <SecondaryContainer direction='row'>
        <EditLine />
        <AddressContainerSmall justifyContent='space-around'>
          <AddressSecondaryContainer>
            <SecondaryTitle>{title}</SecondaryTitle>
            <AddressText>{`${firstName} ${lastName}`}</AddressText>
            <AddressText>{`${primaryAddress?.street1} ${primaryAddress?.street2}`}</AddressText>
            <AddressText>{`${primaryAddress?.city}, ${primaryAddress?.state}, ${primaryAddress?.zipCode} US`}</AddressText>
          </AddressSecondaryContainer>
        </AddressContainerSmall>
      </SecondaryContainer>
    );
  }
};

DeliveryAddress.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
};

const AddressContainerSmall = styled(Flex)`
  margin-left: 8px;
`;

const CustomBox = styled(Box)`
  width: 100%;
  padding-bottom: 20px;
`;

const SecondaryContainer = styled(Flex)`
  width: 100%;
  padding-bottom: 20px;
  align-items: baseline;
  padding-left: 18px;
`;

const AddressContainer = styled(Box)`
  width: 90%;
`;

const AddressSecondaryContainer = styled(Box)`
  width: 100%;
`;

const AddressText = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  letter-spacing: 0%;
  margin: 2px;
`;

const HeaderText = styled(Text)`
  font-size: 22px;
  text-align: center;
  font-weight: 400;
  font-family: ${({ theme }) => theme.typography.familyLarken};
`;

const SecondaryTitle = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0px;
  font-family: ${({ theme }) => theme.typography.familyLarken};
`;

export default DeliveryAddress;
